module.exports = __webpack_public_path__ + "static/orc-hero-e26bcc31d4f827ec09d650e85a97ba25.png";